import { defineAsyncComponent } from 'vue';


export default {
  __name: 'pagination',
  props: {
  currentPage: {
    type: Number,
    default: 1,
  },
  lastPage: {
    type: Number,
    default: 1,
  },
},
  emits: ['update'],
  setup(__props, { emit }) {

const props = __props;





const goToPage = (page) => {
  emit('update', page);
};

const IconArrow = defineAsyncComponent(() =>
  import('@white-label-icon/icon-arrow')
);

return { __sfc: true,props, emit, goToPage, IconArrow }
}

}